import React from 'react';

import { ErrorMessage } from '..';

export const mapValidationOutputToJSX = ({
    type,
    label,
    markup,
    singular,
}: ValidationOutput): JSX.Element => {
    if (singular) {
        return (
            <div key={type} className="font-semibold text-sm">
                {`${label} must `}
                {markup}
            </div>
        );
    }

    return (
        <div key={type}>
            <ErrorMessage>{`${label} must: `}</ErrorMessage>
            {markup}
        </div>
    );
};
